import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import {} from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './aidas-project.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const AidasProjectDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const aidasProjectEntity = useAppSelector(state => state.aidasProject.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="aidasProjectDetailsHeading">AidasProject</h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">ID</span>
          </dt>
          <dd>{aidasProjectEntity.id}</dd>
          <dt>
            <span id="name">Name</span>
          </dt>
          <dd>{aidasProjectEntity.name}</dd>
          <dt>
            <span id="description">Description</span>
          </dt>
          <dd>{aidasProjectEntity.description}</dd>
          <dt>
            <span id="projectType">Project Type</span>
          </dt>
          <dd>{aidasProjectEntity.projectType}</dd>
          <dt>Aidas Customer</dt>
          <dd>{aidasProjectEntity.aidasCustomer ? aidasProjectEntity.aidasCustomer.name : ''}</dd>
        </dl>
        <Button tag={Link} to="/aidas-project" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" /> <span className="d-none d-md-inline">Back</span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/aidas-project/${aidasProjectEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
        </Button>
      </Col>
    </Row>
  );
};

export default AidasProjectDetail;
